import { h } from "omi";

export function PortfolioGridSkeleton() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 auto-rows-fr gap-6 lg:gap-16 mx-auto animate-in slide fade-in slide-in-from-bottom-5 ease-out duration-500 px-4">
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="relative">
          <div className="w-full aspect-square rounded-[48px] overflow-hidden">
            <div className="w-full h-full bg-secondary animate-pulse" />
          </div>
        </div>
      ))}
    </div>
  );
}
